// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8f647b92","28":"ac4c6cb5","36":"1b884a75","529":"1b77c144","930":"858c0bd3"}[chunkId] + ".chunk.js";
};